import _get from 'lodash/get'
import moment from 'moment'

const normalizeHomePlaylist = response => {
  const { data } = response.data
  if (data && data.length > 0) {
    return data.map(
      ({ attributes: { playlists } }) =>
        playlists &&
        playlists.map((playlist, index) => {
          const {
            id,
            type,
            attributes: { title, description, shortDescription, visibility, startTime, endTime, isDark, images },
          } = playlist
          const background = _get(images, 'cover', { portrait: null, landscape: null })
          return {
            ...playlist.attributes,
            id,
            title,
            visibility,
            sortOrder: index + 1,
            startTime,
            endTime,
            description,
            shortDescription: shortDescription || '',
            background,
            isDark: isDark || 0,
            isActive: false,
            type,
          }
        }),
      // .sort((a, b) => a.sortOrder - b.sortOrder)
    )
  }
  return []
}

const normalizeMatchPlaylists = response => {
  const { data } = response.data
  if (data && data.length > 0) {
    let videoData = []
    let Obj = []
    const playlistData = data.map(({ id, attributes: { title, videos, images } }) => {
      const thumbnails = _get(images, 'thumbnails.cover', '')
      videoData =
        videos &&
        videos.map(video => {
          const {
            id,
            attributes: { title, type, startTime, endTime, homeTeam, awayTeam, contentType, permission },
          } = video

          return {
            id,
            type,
            title,
            startTime,
            endTime,
            contentType,
            permission,
            homeTeam,
            awayTeam,
            iconPlaylistUrl: thumbnails,
          }
        })

      if (videoData && videoData.length > 0) {
        return {
          id,
          title,
          thumbnails,
          videos: videoData,
        }
      }
    })
    for (let i = 0; i < playlistData.length; i++) {
      if (playlistData[i] !== undefined && playlistData[i] !== null) {
        let playlistsTemp = playlistData[i]
        Obj.push(playlistsTemp)
      }
    }
    return Obj
  }
  return []
}

const normalizeLeagueList = response => {
  const { data } = response.data
  if (data && data.length > 0) {
    return data.map(result => {
      const {
        id,
        attributes: { title, images },
      } = result

      const thumbnails = _get(images, 'thumbnails.cover', '')

      return {
        id,
        title,
        thumbnails,
      }
    })
  }
  return []
}

const normalizeHomeVideo = response => {
  const { data } = response.data
  if (data && data.length > 0) {
    try {
      const result = data.map(
        ({ attributes: { videos } }) =>
          videos.map(video => {
            const background = _get(video, 'attributes.images.cover', { portrait: null, landscape: null })
            return {
              id: video.id,
              type: video.type,
              ...video.attributes,
              // shortDescription: video.attributes.shortDescription || video.attributes.description,
              background,
              // quotes: quoteLists.length > 0 ? quoteLists[0] : null
            }
          }),
        // .sort((a, b) => a.displayOrder - b.displayOrder)
      )
      return result
    } catch (err) { }
  }
  return []
}

const normalizeHistory = response => {
  const { data } = response.data
  if (data && data.length > 0) {
    return data.map(movieHistory => {
      const historyId = movieHistory.id
      const attr = movieHistory.attributes
      const timePosition = attr.timePosition
      const videoId = attr.videoId
      return attr.videos.map(({ attributes }) => {
        const { title, coverUrl, duration, chapter, thumbnail } = attributes

        return {
          historyId,
          videoId,
          timePosition,
          title,
          chapter: chapter,
          thumbnail: thumbnail ? thumbnail[0] : coverUrl,
          duration: duration || 0,
        }
      })
    })
  }
  return {
    meta: {
      status: 'no_result',
    },
    data: [],
  }
}

const normalizeSearchResult = response => {
  const { data } = response.data
  if (data && data.length > 0) {
    return data.map(result => {
      const {
        id,
        attributes: { images },
      } = result

      const background = _get(images, 'cover', { portrait: null, landscape: null })

      return {
        id,
        ...result.attributes,
        coverUrl: background.portrait,
      }
    })

    return resultArr
  }
  return []
}

const normalizeRecentSearch = response => {
  const { data } = response.data
  if (data && data.length > 0) {
    return data.map(({ id, attributes: { keyword } }) => {
      return {
        id,
        keyword,
      }
    })
  }
  return []
}

const normalizeVideoDetail = response => {
  const { data } = response.data
  if (data && data.length > 0) {
    return data.map(result => {
      const {
        id,
        attributes: { images },
      } = result
      const background = _get(images, 'cover', { portrait: null, landscape: null })
      return {
        id,
        ...result.attributes,
        background,
      }
    })
  }
  return {
    meta: {
      status: 'no_result',
    },
    data: [],
  }
}

const normalizeFeatureBanner = response => {
  const { data } = response.data
  if (data && data.length > 0) {
    const result = data.map(({ attributes: { banners } }) =>
      banners.map(banner => {
        const {
          id,
          type,
          attributes: { name, description, imageUrl, buttonText, link, isDark = 0, ribbon },
        } = banner

        return {
          id,
          type,
          title: name,
          description,
          background: {
            landscape: imageUrl,
            portrait: imageUrl,
          },
          buttonText,
          link,
          isDark,
          ribbon,
        }
      }),
    )
    return result
  }
  return []
}

const normalizeNotifications = response => {
  const { data } = response.data
  // const { notifications } = data
  if (data && data.length > 0) {
    // const { total } = data
    const result = data.map(notification => {
      const {
        id,
        type,
        attributes: {
          imageUrl,
          linkUrl,
          title,
          message,
          status,
          projectId,
          refId,
          startTime,
          endTime,
          createdAt,
          updatedAt,
        },
      } = notification
      return {
        id,
        type,
        imageUrl,
        linkUrl,
        title,
        message,
        status,
        projectId,
        refId,
        startTime,
        endTime,
        createdAt,
        updatedAt,
      }
    })
    return result
  }
  return []
}

const normalizeRecommendation = response => {
  const { data } = response.data
  if (data && data.length > 0) {
    return data.map(dt => {
      const { title } = dt.attributes
      return {
        id: dt.id,
        title,
        ...dt.attributes,
      }
    })
  }
  return []
}

const normalizePartners = response => {
  const { data } = response.data
  if (data && data.length > 0) {
    return data.map(({ id, type, attributes: { name, url, order, createdAt } }) => {
      return {
        id,
        type,
        name,
        url,
        order,
        createdAt,
      }
    })
  }
  return []
}

const normalizeArticles = response => {
  const { data } = response.data
  if (data) {
    const { id, type } = data
    const {
      title,
      author,
      imageUrl,
      imageCaption,
      summary,
      content,
      tags,
      video,
      metaDescription,
      updatedAt,
      menuId,
      relatedVideos,
      readTime,
    } = data.attributes
    return {
      id,
      type,
      title,
      author,
      imageUrl,
      imageCaption,
      summary,
      content,
      tags,
      video,
      metaDescription,
      updatedAt,
      menuId,
      relatedVideos,
      readTime,
    }
  }
  return []
  // console.log(response, 'mau di normalize')
}

const normalizeArticlesList = response => {
  const { data } = response.data
  if (data && data.length > 0) {
    return data.map(({ id, attributes: { title, author, readTime, imageUrl, summary, createdAt, updatedAt } }) => {
      return {
        id,
        title,
        author,
        readTime,
        imageUrl,
        summary,
        createdAt,
        updatedAt,
      }
    })
  }
}

const normalizeArticlesRelated = response => {
  const { data } = response.data
  const articles = data.attributes.articles
  if (articles && articles.length > 0) {
    return articles.map(({ id, attributes: { updatedAt, title, imageUrl } }) => {
      return {
        id,
        updatedAt,
        title,
        imageUrl,
      }
    })
  }
  return []
}

const normalizeMappingCategorizedSubscription = response => {
  const { data } = response.data

  if (data && data.length > 0) {
    return data.map(item => {
      return {
        type: item.type,
        id: item.id,
        name: item.attributes.name,
        order: item.attributes.order,
        payment_methods: item.attributes.payment_methods.map(paymentMethod => {
          return {
            type: paymentMethod.type,
            id: paymentMethod.id,
            subscriptionID: paymentMethod.attributes.subscriptionID,
            name: paymentMethod.attributes.name,
            logo: paymentMethod.attributes.logo,
            url: paymentMethod.attributes.url,
            fee: paymentMethod.attributes.fee,
            feeUom: paymentMethod.attributes.feeUom,
            order: paymentMethod.attributes.order,
            enable: paymentMethod.attributes.enable,
            channel: paymentMethod.attributes.channel,
            clientLock: paymentMethod.attributes.clientLock,
            strictClientLock: paymentMethod.attributes.strictClientLock,
          }
        }),
      }
    })
  }
}

const normalizeMappingSubscription = response => {
  const { data } = response.data

  if (data && data.length > 0) {
    return data.map(
      ({
        id,
        type,
        attributes: {
          subscriptionID,
          name,
          logo,
          url,
          fee,
          feeUom,
          order,
          enable,
          channel,
          clientLock,
          strictClientLock,
        },
      }) => {
        return {
          id,
          type,
          subscriptionID,
          name,
          logo,
          url,
          fee,
          feeUom,
          order,
          enable,
          channel,
          clientLock,
          strictClientLock,
        }
      },
    )
  }
  return []
}

const normalizeSelectedAttributes = response => {
  const { data } = response.data
  if (data && data.length > 0) {
    return data.map(dt => {
      const {
        title,
        images,
        description,
        visibility,
        contentType,
        countryCode,
        sortOrder,
        parentId,
        status,
        isDark,
        viewMorePlaylistId,
        menuId,
        seo,
        seasonNumber,
      } = dt.attributes
      const { id, type } = dt
      const background = _get(images, 'cover', { portrait: null, landscape: null })
      const thumbnails = _get(images, 'thumbnails.cover', '')
      return {
        id,
        type,
        title,
        background,
        thumbnails,
        description,
        visibility,
        contentType,
        countryCode,
        sortOrder,
        parentId,
        status,
        isDark,
        viewMorePlaylistId,
        menuId,
        seo,
        seasonNumber,
      }
    })
  }
  return []
}

const normalizePromoDetail = response => {
  const { data } = response.data
  if (data && data.length > 0) {
    return data.map(({ id, type, attributes: { name, title, description, imageUrl, formula, voucherCode } }) => {
      return {
        id,
        type,
        name,
        title,
        description,
        imageUrl,
        formula,
        voucherCode,
      }
    })
  }
  return []
}

const normalizePromoList = response => {
  const { data } = response.data
  if (data && data.length > 0) {
    return data.map(({ id, type, attributes: { name, title, imageUrl, formula } }) => {
      return {
        id: name === null ? '' : id,
        type: name === null ? '' : type,
        name: name === null ? '' : name,
        title: title === null ? '' : title,
        imageUrl: imageUrl === null ? '' : imageUrl,
        formula: JSON.parse(formula),
      }
    })
  }
  return []
}

const normalizeContinueWatching = response => {
  const { attributes } = response.data.data
  if (attributes && attributes.length > 0) {
    return attributes.map(
      ({ type, id, attributes: { images, title, description, duration, timePosition, ribbon } }) => {
        const background = {
          landscape: _get(images, 'cover.landscape', ''),
        }
        return {
          id,
          type,
          title,
          description,
          duration,
          timePosition,
          background,
          ribbon,
        }
      },
    )
  }

  return []
}

const normalizeRecommendationUser = response => {
  const { data } = response.data
  if (data && data.length > 0) {
    return data.map(({ id, attributes: {
      ...result
    } }) => {
      return {
        id,
        ...result,
      }
    })
  }
  return []
}

const normalizeOrderHistory = response => {
  const data = response.data
  if (data && data.length > 0) {
    return data.map(
      ({
        type,
        id,
        attributes: {
          subscriptionId,
          order_status,
          paymentMethodId,
          orderId,
          paymentAmount,
          totalPrice,
          promoAmount,
          promoCode,
          promoClaimId,
          paymentMethodName,
          paidAt,
          pendingAt,
        },
      }) => {
        return {
          type,
          id,
          subscriptionId,
          order_status,
          paymentMethodId,
          orderId,
          paymentAmount,
          totalPrice,
          promoAmount,
          promoCode,
          promoClaimId,
          paymentMethodName,
          paidAt,
          pendingAt,
        }
      },
    )
  }

  return []
}

const normalizeSubscriptionDetail = response => {
  const data = response.data
  if (data && data.length > 0) {
    return data.map(({ ID, Title, Description, ExpireAt, CreatedAt }) => {
      return {
        id: ID,
        title: Title,
        description: JSON.parse(Description).miniDescription,
        expiryTime: ExpireAt,
        createdAt: CreatedAt,
      }
    })
  }

  return []
}

const normalizeOrderHistoryById = response => {
  const data = response.data
  if (data) {
    const {
      id,
      userID,
      orderID,
      paymentMethodID,
      paymentMethodName,
      paymentFeature,
      paymentFeatureType,
      qrImageBase64,
      status,
      identifier,
      htmlRedirection,
      expiryTime,
      serverTime,
      expiryDuration,
    } = data

    return {
      id,
      userID,
      orderID,
      paymentMethodID,
      paymentMethodName,
      paymentFeature,
      paymentFeatureType,
      qrImageBase64,
      status,
      identifier,
      htmlRedirection,
      expiryTime,
      serverTime,
      expiryDuration,
    }
  }
}

const normalizeInboxList = response => {
  const data = response.data.data
  if (data && data.length > 0) {
    return data.map(
      ({
        id,
        type,
        attributes: {
          template: { lang, categoryID, startTime, endTime, defaultLang },
          status,
          createdAt,
          updatedAt,
          readAt,
        },
      }) => {
        return {
          id,
          type,
          lang,
          categoryID,
          startTime,
          endTime,
          defaultLang,
          status,
          createdAt,
          updatedAt,
          readAt,
        }
      },
    )
  }

  return []
}

const normalizeInboxDetail = response => {
  const data = response.data.data
  if (data) {
    const {
      id,
      type,
      attributes: {
        createdAt,
        readAt,
        status,
        template: { categoryID, defaultLang, endTime, startTime, lang },
      },
    } = data

    return {
      id,
      type,
      createdAt,
      readAt,
      status,
      categoryID,
      defaultLang,
      endTime,
      startTime,
      lang,
    }
  }
}

const normalizeInboxCategory = response => {
  const data = response.data.data
  if (data && data.length > 0) {
    return data.map(({ id, type, attributes: { name, description, displayOrder, createdAt } }) => {
      return {
        id,
        type,
        name,
        description,
        displayOrder,
        createdAt,
      }
    })
  }

  return []
}

const normalizeCounterInbox = response => {
  const data = response.data.data
  if (data) {
    const {
      id,
      type,
      attributes: { unread },
    } = data
    return {
      id,
      type,
      unread,
    }
  }
  return null
}

const normalizeStandingsTeam = response => {
  const data = response.data.data
  if (data && data.length > 0) {
    return data.map(
      ({
        id,
        type,
        attributes: {
          name,
          officialWebsiteUrl,
          home,
          logo,
          homeWebsiteUrl,
          shortName,
          country,
          countryCode,
          abbreviation,
          createdAt,
        },
      }) => {
        return {
          id,
          type,
          name,
          officialWebsiteUrl,
          home,
          logo,
          homeWebsiteUrl,
          shortName,
          country,
          countryCode,
          abbreviation,
        }
      },
    )
  }

  return []
}

const normalizeBatchReminders = response => {
  const data = response.data.data
  if (data.attributes && data.attributes.length > 0) {
    return data.attributes.map(({ id, type, attributes: { status } }) => {
      return {
        id,
        type,
        status,
      }
    })
  }
  return []
}

const normalizeGetAllCities = response => {
  const { data } = response.data

  if (data && data.length > 0) {
    return data.map(({ id, type, attributes: { city, project_id, status } }) => {
      return {
        id: id === null ? '' : id,
        type: type === null ? '' : type,
        city: city === null ? '' : city,
        project_id: project_id === null ? '' : project_id,
        status: status === null ? '' : status,
      }
    })
  }

  return []
}

const normalizeGetDistrictByCityId = response => {
  const { data } = response.data

  if (data && data.length > 0) {
    return data.map(({ id, type, attributes: { district, city_id, status, project_id } }) => {
      return {
        id: id === null ? '' : id,
        type: type === null ? '' : type,
        district: district === null ? '' : district,
        project_id: project_id === null ? '' : project_id,
        city_id: city_id === null ? '' : city_id,
        status: status === null ? '' : status,
      }
    })
  }

  return []
}

const normalizeMolaHub = response => {
  const { data } = response.data
  if (data) {
    const {
      id,
      type,
      attributes: { channels, name, playlistId, pageUrl },
    } = data
    return {
      id,
      type,
      channels,
      name,
      playlistId,
      pageUrl,
    }
  }
}

export default {
  normalizeHomePlaylist,
  normalizeHomeVideo,
  normalizeHistory,
  normalizeSearchResult,
  normalizeRecentSearch,
  normalizeVideoDetail,
  normalizeFeatureBanner,
  normalizeRecommendation,
  normalizeMatchPlaylists,
  normalizeLeagueList,
  normalizeNotifications,
  normalizePartners,
  normalizeArticles,
  normalizeArticlesList,
  normalizeArticlesRelated,
  normalizeMappingSubscription,
  normalizeMappingCategorizedSubscription,
  normalizeSelectedAttributes,
  normalizePromoDetail,
  normalizePromoList,
  normalizeContinueWatching,
  normalizeRecommendationUser,
  normalizeOrderHistory,
  normalizeSubscriptionDetail,
  normalizeOrderHistoryById,
  normalizeInboxList,
  normalizeInboxDetail,
  normalizeInboxCategory,
  normalizeCounterInbox,
  normalizeStandingsTeam,
  normalizeBatchReminders,
  normalizeGetAllCities,
  normalizeGetDistrictByCityId,
  normalizeMolaHub,
}
